// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const commandsClient = createTypedClient();
export const createCommandsClient = (config) => createTypedClient(config);
